import { useEffect, useState } from 'react';
import { IoRadioOutline } from 'react-icons/io5';
import { useWebSocket } from '../../contexts/WebSocketContext';
import './LiveTicker.css';

const MAX_ENTRIES = 5;

/**
 * "Someone from Grace Church just read Psalm 23." (WS1)
 *
 * Driven by the existing `reading-report-created` broadcast. The payload
 * carries a church name and a reference and never a person's name, so there is
 * nothing here to leak.
 */
const LiveTicker = () => {
  const { lastReadingReportCreated } = useWebSocket();
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    const event = lastReadingReportCreated;
    if (!event) return;

    // Bulk events arrive as { reports, summary }; those get no ticker line —
    // one person reporting a whole book shouldn't flood the feed.
    if (event.reports) return;
    if (!event.book || !event.chapter) return;

    const who = event.churchName ? `Someone from ${event.churchName}` : 'Someone';
    const entry = {
      id: event.id || `${event.chapterId}-${Date.now()}`,
      text: `${who} just read ${event.book} ${event.chapter}.`
    };

    setEntries(prev => {
      if (prev[0]?.id === entry.id) return prev;
      return [entry, ...prev].slice(0, MAX_ENTRIES);
    });
  }, [lastReadingReportCreated]);

  if (entries.length === 0) return null;

  return (
    <div className="live-ticker" aria-live="polite">
      <span className="live-ticker-badge">
        <IoRadioOutline size={14} aria-hidden="true" />
        Live
      </span>
      <ul className="live-ticker-list">
        {entries.map(entry => (
          <li key={entry.id}>{entry.text}</li>
        ))}
      </ul>
    </div>
  );
};

export default LiveTicker;
